import React from "react";
import { Chip } from "@mui/material";
import { getBadgeStyles } from "../../../../components/ui/badgeColors";
import { getColorEstadoVenta, getEtiquetaEstadoVenta } from "../../helpers/estadosVentas";

/**
 * Badge del estado de un pedido de venta (colores en COLOR_ESTADO_VENTA)
 */
const EstadoVentaBadge = ({ estado }) => (
    <Chip
        label={getEtiquetaEstadoVenta(estado)}
        size="small"
        sx={getBadgeStyles(getColorEstadoVenta(estado))}
    />
);

export default React.memo(EstadoVentaBadge);
